import { Check, ChevronLeft, ChevronRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

export const STEPS = [
  { key: 1, title: "Pilih Siswa", hint: "Data identitas terisi otomatis" },
  { key: 2, title: "Isi Data (Indonesia)", hint: "Lengkapi & koreksi SPOK" },
  { key: 3, title: "Terjemahan EN / 日本語", hint: "Otomatis, bisa diedit" },
  { key: 4, title: "Template & Cetak", hint: "Preview, unduh, lampirkan" },
];

export const CVStepper = ({ step, onStep, done }) => (
  <ol className="grid grid-cols-4 gap-1 mb-4" data-testid="cv-stepper">
    {STEPS.map((s, i) => {
      const active = step === s.key, complete = done[s.key];
      return <li key={s.key} className="min-w-0">
        <button type="button" onClick={() => onStep(s.key)} className={cn("w-full text-left rounded-lg border px-3 py-2 transition-colors", active ? "border-primary bg-primary/5" : "border-border hover:bg-muted/60")} data-testid={`cv-step-${s.key}`}>
          <div className="flex items-center gap-2"><span className={cn("flex h-6 w-6 shrink-0 items-center justify-center rounded-full text-[11px] font-bold", complete ? "bg-emerald-600 text-white" : active ? "bg-primary text-primary-foreground" : "bg-muted text-muted-foreground")}>{complete ? <Check className="h-3.5 w-3.5" /> : s.key}</span><p className={cn("text-xs font-semibold truncate", !active && !complete && "text-muted-foreground")}>{s.title}</p></div>
          <p className="hidden md:block text-[10px] text-muted-foreground mt-1 truncate">{s.hint}</p>
        </button>
        <div className={cn("mt-1 h-1 rounded-full", complete ? "bg-emerald-500" : active ? "bg-primary" : "bg-muted")} />
      </li>;
    })}
  </ol>
);

export const StepNav = ({ step, onStep, nextLabel, nextDisabled, children }) => (
  <div className="flex flex-wrap items-center justify-between gap-2 mt-4 pt-3 border-t" data-testid="cv-step-nav">
    <Button variant="outline" size="sm" onClick={() => onStep(step - 1)} disabled={step <= 1} data-testid="cv-step-prev"><ChevronLeft className="h-4 w-4 mr-1" />Kembali</Button>
    <div className="flex gap-2 flex-wrap">{children}</div>
    {step < 4 && <Button size="sm" onClick={() => onStep(step + 1)} disabled={nextDisabled} data-testid="cv-step-next">{nextLabel || "Lanjut"}<ChevronRight className="h-4 w-4 ml-1" /></Button>}
  </div>
);
